module.exports = __webpack_public_path__ + "img/R6__1235.f0089b94.jpeg";